var App = App || {};

App.NavMobile = (function ($) {
    'use strict';

    function Init() {

        const offcanvas = $("#offcanvas-nav-mobile");
        const levels = offcanvas.find(".nav-mobile-levels");
        const buttons = offcanvas.find("button[data-nav-mobile]");

        offcanvas.on("hidden.bs.offcanvas", function () {
            // reset
        });

        buttons.on("click", function () {

            const currentLevel = parseInt(levels.attr("data-level"));
            const currentItem = levels.find(`.nav-mobile-level[data-level="${currentLevel}"]`).find(".nav-mobile-level-item.active");

            const nextItem = $(`#${$(this).attr("aria-controls")}`);
            const nextLevel = parseInt(nextItem.parents(".nav-mobile-level").attr("data-level"));

            currentItem.removeClass("active");
            nextItem.addClass("active");

            levels.attr("data-level", nextLevel);

        });
    }

    return {
        Init: Init
    };

})(jQuery);